var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-edit clan-edit"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-12"},[_c('InformationClan')],1)]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-12"},[_c('SocialLinks')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }